import { render } from "./GeneralGroupGrid.vue?vue&type=template&id=89d66842"
import script from "./GeneralGroupGrid.vue?vue&type=script&lang=js"
export * from "./GeneralGroupGrid.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__